import React from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

// Import Bootstrap versions (5 available portals!)
import TeacherPortal from './components/brischool-teacher-bootstrap';
import ParentPortal from './components/brischool-parent-bootstrap';
import StudentPortal from './components/brischool-student-bootstrap';
import AdminPortal from './components/brischool-admin-bootstrap';
import AcademicDashboard from './components/brischool-academic-bootstrap';
//import FinanceDashboard from './components/brischool-finance-bootstrap';
//import HealthManagement from './components/brischool-health-bootstrap';

// Import Bootstrap versions (available portals)
import TeacherGradebook from './components/ishworld-teacher-gradebook-demo';
import AcademicTimetable from './components/ishworld-timetable-cover-demo';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PortalSelector />} />
        <Route path="/teacher" element={<TeacherPortal />} />
        <Route path="/parent" element={<ParentPortal />} />
        {/* Uncomment routes as Bootstrap versions become available */}
        <Route path="/student" element={<StudentPortal />} />
        <Route path="/admin" element={<AdminPortal />} />
        <Route path="/academic" element={<AcademicDashboard />} /> 
		<Route path="/gradebook" element={<TeacherGradebook />} />
        <Route path="/timetable" element={<AcademicTimetable />} /> 
        {/* <Route path="/finance" element={<FinanceDashboard />} /> */}
        {/* <Route path="/health" element={<HealthManagement />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

// Portal Selector Landing Page (Bootstrap Styling)
function PortalSelector() {
  const navigate = useNavigate();

  const portals = [
    { 
      path: '/teacher', 
      title: 'Teacher Portal', 
      emoji: '👨‍🏫', 
      color: 'primary',
      description: 'Manage classes, grade assessments, view student health',
      available: true
    },
    { 
      path: '/parent', 
      title: 'Parent Portal', 
      emoji: '👨‍👩‍👧', 
      color: 'success',
      description: 'Track academic progress, financial account, health records',
      available: true
    },
    { 
      path: '/student', 
      title: 'Student Portal', 
      emoji: '🎓', 
      color: 'info',
      description: 'Submit work, view grades, check timetable',
      available: true
    },
    { 
      path: '/admin', 
      title: 'Admin Portal', 
      emoji: '👔', 
      color: 'dark',
      description: 'Manage staff, schedules, and operations',
      available: true
    },
    { 
      path: '/academic', 
      title: 'Academic Dashboard', 
      emoji: '📊', 
      color: 'secondary',
      description: 'Performance analytics and curriculum tracking',
      available: true
    },
	{ 
      path: '/gradebook', 
      title: 'Teacher Gradebook', 
      emoji: '📊', 
      color: 'secondary',
      description: 'Performance analytics and curriculum tracking',
      available: true
    },
	{ 
      path: '/timetable', 
      title: 'Academic Timetable', 
      emoji: '📊', 
      color: 'secondary',
      description: 'Performance analytics and curriculum tracking',
      available: true
    },
    { 
      path: '/finance', 
      title: 'Finance Dashboard', 
      emoji: '💰', 
      color: 'warning',
      description: 'Tuition management and expense reports',
      available: false
    },
    { 
      path: '/health', 
      title: 'Health Management', 
      emoji: '🏥', 
      color: 'danger',
      description: 'Medical records and immunization tracking',
      available: false
    }
  ];

  return (
    <div className="min-vh-100" style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      {/* Header */}
      <div className="container py-5">
        <div className="text-center text-white mb-5">
          <h1 className="display-1 fw-bold mb-3" style={{fontSize: '5rem'}}>BriSchool</h1>
          <p className="lead fs-3">Complete K-12 School Management System</p>
          <p className="opacity-75">Integrated Academic, Financial & Health Data</p>
        </div>

        {/* Portal Cards */}
        <div className="row justify-content-center">
          <div className="col-lg-10 col-xl-9">
            <div className="card shadow-lg border-0 rounded-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="text-center mb-4">Select Your Portal</h2>
                
                <div className="row g-3 mb-4">
                  {portals.map((portal) => (
                    <div key={portal.path} className="col-md-6 col-lg-4">
                      <button
                        onClick={() => portal.available && navigate(portal.path)}
                        disabled={!portal.available}
                        className={`btn btn-${portal.color} w-100 p-4 text-start position-relative border-0 shadow-sm ${portal.available ? '' : 'opacity-50'}`}
                        style={{
                          height: '140px',
                          transition: 'all 0.3s ease',
                          cursor: portal.available ? 'pointer' : 'not-allowed'
                        }}
                        onMouseOver={(e) => {
                          if (portal.available) {
                            e.currentTarget.style.transform = 'translateY(-4px)';
                            e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.2)';
                          }
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '';
                        }}
                      >
                        <div className="d-flex flex-column h-100 justify-content-between">
                          <div>
                            <div className="fs-1 mb-2">{portal.emoji}</div>
                            <h5 className="mb-1 fw-bold">{portal.title}</h5>
                            <small className="opacity-75" style={{fontSize: '0.75rem'}}>
                              {portal.description}
                            </small>
                          </div>
                          {!portal.available && (
                            <small className="text-end mt-2 opacity-75 fst-italic">
                              Coming Soon
                            </small>
                          )}
                          {portal.available && (
                            <small className="text-end mt-2 fw-bold">
                              Enter →
                            </small>
                          )}
                        </div>
                      </button>
                    </div>
                  ))}
                </div>

                {/* Status Section */}
                <div className="alert alert-light border-0 shadow-sm">
                  <div className="row text-center text-md-start">
                    <div className="col-md-4 mb-3 mb-md-0">
                      <h6 className="fw-bold text-success mb-2">✅ Available Now</h6>
                      <small className="d-block">• Teacher Portal</small>
                      <small className="d-block">• Parent Portal</small>
                    </div>
                    <div className="col-md-4 mb-3 mb-md-0">
                      <h6 className="fw-bold text-warning mb-2">⏳ Converting Soon</h6>
                      <small className="d-block">• 5 more portals</small>
                      <small className="d-block">• Bootstrap migration</small>
                    </div>
                    <div className="col-md-4">
                      <h6 className="fw-bold text-primary mb-2">🎨 Why Bootstrap?</h6>
                      <small className="d-block">• No config files</small>
                      <small className="d-block">• Just works!</small>
                    </div>
                  </div>
                </div>

                {/* Features */}
                <div className="mt-4">
                  <h6 className="text-muted text-center mb-3">System Features</h6>
                  <div className="row g-2 small">
                    <div className="col-6 col-md-3">
                      <div className="text-center p-2 bg-light rounded">
                        <div className="mb-1">🔗</div>
                        <strong>Integrated</strong>
                      </div>
                    </div>
                    <div className="col-6 col-md-3">
                      <div className="text-center p-2 bg-light rounded">
                        <div className="mb-1">📱</div>
                        <strong>Responsive</strong>
                      </div>
                    </div>
                    <div className="col-6 col-md-3">
                      <div className="text-center p-2 bg-light rounded">
                        <div className="mb-1">🔒</div>
                        <strong>Secure</strong>
                      </div>
                    </div>
                    <div className="col-6 col-md-3">
                      <div className="text-center p-2 bg-light rounded">
                        <div className="mb-1">⚡</div>
                        <strong>Fast</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="text-center text-white mt-4">
              <p className="small opacity-75 mb-1">© 2025 BriSchool. All rights reserved.</p>
              <p className="small opacity-75">Comprehensive K-12 School Management System</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;